import groupBy from 'lodash/groupBy';
import sortBy from 'lodash/sortBy';

import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorHandlerThunk } from '../../App/App.thunk';
import { statusControlService } from './StatusControl.service';
import { CreateStatusDto, Status, UpdateStatusDto } from './StatusControl.type';

const THUNK_PREFIX = 'statusControl';

export const getStatusControlListThunk = createAsyncThunk(
  `${THUNK_PREFIX}/getStatusControlListThunk`,
  async (
    params: { q?: string; page?: number | string; sort?: string },
    thunkAPI,
  ) => {
    try {
      // TODO find better solution for getting all statuses
      const response = await statusControlService.getList({
        ...params,
        perPage: 1,
      });
      const responseWithAllData = await statusControlService.getList({
        ...params,
        perPage: response?.data?.pagination?.total,
      });
      const { data } = responseWithAllData.data;
      let options: Status[] = [];
      const groupOptions = groupBy(data, (item: any) => {
        return item.event.name;
      });
      for (const option in groupOptions) {
        const value = sortBy(groupOptions[option], ['order']);
        options = [...options, ...value];
      }
      return { ...responseWithAllData.data, data: options };
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);

export const createStatusControlThunk = createAsyncThunk(
  `${THUNK_PREFIX}/createStatusControlThunk`,
  async (status: CreateStatusDto, thunkAPI) => {
    try {
      const response = await statusControlService.create(status);
      return response.data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);

export const updateStatusControlThunk = createAsyncThunk(
  `${THUNK_PREFIX}/updateStatusControlThunk`,
  async (status: UpdateStatusDto, thunkAPI) => {
    try {
      const response = await statusControlService.update(status);
      return response.data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);

export const deleteStatusControlThunk = createAsyncThunk(
  `${THUNK_PREFIX}/deleteStatusControlThunk`,
  async (id: number, thunkAPI) => {
    try {
      await statusControlService.delete(id);
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);
